'use client';

import { createContext, ReactNode, useContext } from 'react';

export type FrameworkContextValue = 'NextJS' | 'React';

const frameworkContext = createContext<FrameworkContextValue | undefined>(undefined);

export function FrameworkContextProvider({ children, value }: { children: ReactNode; value: FrameworkContextValue }) {
    return <frameworkContext.Provider value={value}>{children}</frameworkContext.Provider>;
}

export function useFramework() {
    const context = useContext(frameworkContext);

    if (!context) {
        return 'React';
    }

    return context;
}
